import { cn, createBEM } from "@/libs";
import { ComponentBase } from "@/types";
import { useTitle } from "ahooks";
import { Button } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import { CustomerIcon } from "../CustomerIcon";
import { Icon } from "../Icon";
import "./index.scss";
export interface HeaderProps extends ComponentBase.Component {
  title: string;
  leftActions?: HeaderActionType | HeaderActionType[];
  rightActions?: HeaderActionType | HeaderActionType[];
}
export const Header = ({
  className,
  children,
  title,
  leftActions = [],
  rightActions = []
}: HeaderProps) => {
  useTitle(title, {
    restoreOnUnmount: true
  });
  const b = createBEM("i-header");
  const $title = <div className={b("title")}>{title}</div>;
  return <div className={cn(b(), className)} data-sentry-component="Header" data-sentry-source-file="index.tsx">
      <div className={b("actions", ["left"])}>{leftActions}</div>
      {children || $title}
      <div className={b("actions", ["right"])}>{rightActions}</div>
    </div>;
};
export interface HeaderActionProps extends ComponentBase.Component {
  onClick?: () => void;
}
export interface HeaderActionType extends React.ReactElement<HeaderActionProps> {}
export const HeaderAction = ({
  children,
  onClick
}: HeaderActionProps) => {
  const b = createBEM("i-header_action");
  return <Button fill="none" className={b()} onClick={onClick} data-sentry-element="Button" data-sentry-component="HeaderAction" data-sentry-source-file="index.tsx">
      {children}
    </Button>;
};
export const HeaderActionBack = () => {
  const navigate = useNavigate();
  return <HeaderAction key="back" onClick={() => {
    navigate(-1);
  }} data-sentry-element="HeaderAction" data-sentry-component="HeaderActionBack" data-sentry-source-file="index.tsx">
      <Icon name="header-back" size="24px" data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
    </HeaderAction>;
};
export const HeaderActionCustomerService = () => {
  const navigate = useNavigate();
  return (
    // <HeaderAction
    //   key="kefu"
    //   // onClick={() => {
    //   //   navigate(-1);
    //   // }}
    // >
    <CustomerIcon data-sentry-element="CustomerIcon" data-sentry-component="HeaderActionCustomerService" data-sentry-source-file="index.tsx" />
    // </HeaderAction>
    // </HeaderAction>
  );
};